import React, { useContext } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import {
  getOptionsTranslation,
  presetSensibilitaGraficoOptions,
  presetGraficoDiDefaultOptions,
} from "../../utils/miplus";
import { convertValue, getUnit } from "../../utils/unitsConverter";

export default function ConfResumeComponent(props) {
  const { t } = useContext(LocalesContext);
  const isImperial = props.unitsSystem === 'imperial';
  const config = props.configuration;

  // Calcola il numero di file attivi dalle maschere
  const getActiveFilesCount = () => {
    if (!config?.masks) return 0;
    
    let count = 0;
    if (config.masks.b1 && config.masks.b1[0] > 0) count++;
    if (config.masks.b2 && config.masks.b2[0] > 0) count++;

    return count;
  };

  return (
    <div>
      {/* File Management Section */}
      <table className="c-table" style={{ marginBottom: '30px' }}>
        <thead>
            <tr>
                <th>{t("GestioneFile")}</th>
                <th></th>
            </tr>    
        </thead>
        <tbody>
          <tr>
            <th>{t("NumeroFile")}</th>
            <td>
              {getActiveFilesCount()}
            </td>
            <td className="mobile">
              <span><p>{t("NumeroFile")}</p><p>{getActiveFilesCount()}</p></span>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Configuration Section */}
      <table className="c-table">
        <thead>
            <tr>
                <th>{t("Configurazione")}</th>
                <th>B1</th>
                <th>B2</th>
            </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t("Interfila")}</th>
            <td>
              {convertValue(config?.b1?.irow || 0, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
            <td>
              {convertValue(config?.b2?.irow || 0, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
            <td className="mobile">
              <span><p>{t("Interfila")}</p><p></p></span>
              <span><p>B1</p><p>{convertValue(config?.b1?.irow || 0, 'length', isImperial)} {getUnit('length', isImperial)}</p></span>
              <span><p>B2</p><p>{convertValue(config?.b2?.irow || 0, 'length', isImperial)} {getUnit('length', isImperial)}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("DistanzaSemina")}</th>
            <td>
              {convertValue(config?.b1?.sdd || 0, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
            <td>
              {convertValue(config?.b2?.sdd || 0, 'length', isImperial)} {getUnit('length', isImperial)}
            </td>
            <td className="mobile">
              <span><p>{t("DistanzaSemina")}</p><p></p></span>
              <span><p>B1</p><p>{convertValue(config?.b1?.sdd || 0, 'length', isImperial)} {getUnit('length', isImperial)}</p></span>
              <span><p>B2</p><p>{convertValue(config?.b2?.sdd || 0, 'length', isImperial)} {getUnit('length', isImperial)}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("Investimento")}</th>
            <td>
              {convertValue(config?.b1?.dose || 0, 'investment', isImperial)} {getUnit('investment', isImperial)}
            </td>
            <td>
              {convertValue(config?.b2?.dose || 0, 'investment', isImperial)} {getUnit('investment', isImperial)}
            </td>
            <td className="mobile">
              <span><p>{t("Investimento")}</p><p></p></span>
              <span><p>B1</p><p>{convertValue(config?.b1?.dose || 0, 'investment', isImperial)} {getUnit('investment', isImperial)}</p></span>
              <span><p>B2</p><p>{convertValue(config?.b2?.dose || 0, 'investment', isImperial)} {getUnit('investment', isImperial)}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("NumeroForiDisco")}</th>
            <td>{config?.b1?.hls || 0} n°</td>
            <td>{config?.b2?.hls || 0} n°</td>
            <td className="mobile">
              <span><p>{t("NumeroForiDisco")}</p><p></p></span>
              <span><p>B1</p><p>{config?.b1?.hls || 0} n°</p></span>
              <span><p>B2</p><p>{config?.b2?.hls || 0} n°</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("DiametroForiDisco")}</th>
            <td>
              {convertValue((config?.b1?.hls_dia || 0) / 10, 'height', isImperial)} {getUnit('height', isImperial)}
            </td>
            <td>
              {convertValue((config?.b2?.hls_dia || 0) / 10, 'height', isImperial)} {getUnit('height', isImperial)}
            </td>
            <td className="mobile">
              <span><p>{t("DiametroForiDisco")}</p><p></p></span>
              <span><p>B1</p><p>{convertValue((config?.b1?.hls_dia || 0) / 10, 'height', isImperial)} {getUnit('height', isImperial)}</p></span>
              <span><p>B2</p><p>{convertValue((config?.b2?.hls_dia || 0) / 10, 'height', isImperial)} {getUnit('height', isImperial)}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("GraficoDiDefault")}</th>
            <td>
              {getOptionsTranslation(
                presetGraficoDiDefaultOptions(t),
                config?.meta?.grafici_semina_tipo || 'iso'
              )}
            </td>
            <td>
              {getOptionsTranslation(
                presetGraficoDiDefaultOptions(t),
                config?.meta?.grafici_semina_tipo || 'iso'
              )}
            </td>
            <td className="mobile">
              <span><p>{t("GraficoDiDefault")}</p><p>{getOptionsTranslation(presetGraficoDiDefaultOptions(t), config?.meta?.grafici_semina_tipo || 'iso')}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("SensibilitaGrafico")}</th>
            <td>
              {getOptionsTranslation(
                presetSensibilitaGraficoOptions(t),
                config?.meta?.grafici_semina_sensibilita || 'medium'
              )}
            </td>
            <td>
              {getOptionsTranslation(
                presetSensibilitaGraficoOptions(t),
                config?.meta?.grafici_semina_sensibilita || 'medium'
              )}
            </td>
            <td className="mobile">
              <span><p>{t("SensibilitaGrafico")}</p><p>{getOptionsTranslation(presetSensibilitaGraficoOptions(t), config?.meta?.grafici_semina_sensibilita || 'medium')}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("SogliaAllarmeQualita")}</th>
            <td>{((config?.al_cnf?.sd_q_th || 0) / 10)}%</td>
            <td>{((config?.al_cnf?.sd_q_th || 0) / 10)}%</td>
            <td className="mobile">
              <span><p>{t("SogliaAllarmeQualita")}</p><p>{((config?.al_cnf?.sd_q_th || 0) / 10)}%</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("SogliaAllarmePopolazione")}</th>
            <td>{config?.al_cnf?.p_th_min || 0}% - {config?.al_cnf?.p_th_max || 0}%</td>
            <td>{config?.al_cnf?.p_th_min || 0}% - {config?.al_cnf?.p_th_max || 0}%</td>
            <td className="mobile">
              <span><p>{t("SogliaAllarmePopolazione")}</p><p>{config?.al_cnf?.p_th_min || 0}% - {config?.al_cnf?.p_th_max || 0}%</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("LivelloAllarmeGrafico")}</th>
            <td>{config?.meta?.grafici_semina_livello_grafico_allarme || 0}%</td>
            <td>{config?.meta?.grafici_semina_livello_grafico_allarme || 0}%</td>
            <td className="mobile">
              <span><p>{t("LivelloAllarmeGrafico")}</p><p>{config?.meta?.grafici_semina_livello_grafico_allarme || 0}%</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("LivelloDepressioneMin")}</th>
            <td>
              {convertValue(config?.al_cnf?.mbar_min || 0, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
            <td>
              {convertValue(config?.al_cnf?.mbar_min || 0, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
            <td className="mobile">
              <span><p>{t("LivelloDepressioneMin")}</p><p>{convertValue(config?.al_cnf?.mbar_min || 0, 'pressure', isImperial)} {getUnit('pressure', isImperial)}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t("LivelloDepressioneMax")}</th>
            <td>
              {convertValue(config?.al_cnf?.mbar_max || 0, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
            <td>
              {convertValue(config?.al_cnf?.mbar_max || 0, 'pressure', isImperial)} {getUnit('pressure', isImperial)}
            </td>
            <td className="mobile">
              <span><p>{t("LivelloDepressioneMax")}</p><p>{convertValue(config?.al_cnf?.mbar_max || 0, 'pressure', isImperial)} {getUnit('pressure', isImperial)}</p></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

ConfResumeComponent.propTypes = {
  configuration: PropTypes.object.isRequired,
  unitsSystem: PropTypes.string,
};

ConfResumeComponent.defaultProps = {
  configuration: {},
  unitsSystem: 'metric'
};